import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {GlobalConstantsComponent} from '../../../shared/global-constants/global-constants.component';
import {UserService} from '../../../services/user-services/user.service';
import {AlertService} from '../../../services/alert.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {finalize, first} from 'rxjs/operators';
import {DocumentsSharedService} from '../../../services/documents-shared.service';
import {DocumentsService} from 'src/app/services/user-services/documents.service';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DatePipe, formatDate, NgFor, NgIf} from '@angular/common';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {UploadFileComponent} from '../../../shared/components/upload-file/upload-file.component';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {Select2Module} from 'ng-select2-component';
import {PlatformService} from '../../../services/platform-service.service';

@Component({
    selector: 'app-doc-management',
    templateUrl: './doc-management.component.html',
    styleUrls: ['./doc-management.component.scss'],
    standalone: true,
    imports: [NgIf, MatMenuModule, MatIconModule, UploadFileComponent, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgxIntlTelInputModule, MatDatepickerModule, MatSelectModule, NgFor, MatOptionModule, DatePipe, Select2Module]
})
export class DocManagementComponent implements OnInit {
  @Input() public doc: any = {};
  @Input() public reload: boolean;
  @Output() public isDeleted: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('select2Element') select2Element: any;

  private rawMediaURL: string = GlobalConstantsComponent.rawMediaURL;
  public isRegenerating: boolean = false;
  public fullInfo;
  public properties:any = [];
  public form: UntypedFormGroup;
  public hasLoad = false;
  public loading = false;

  constructor(
    private userService: UserService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private documentService: DocumentsSharedService,
    private dService: DocumentsService,
    private fb: UntypedFormBuilder,
    private platformService : PlatformService
  ) { }

  ngOnInit(): void {
    if(this.platformService.isBrowserPlatform()){
      if (this.doc['path']) {
        const pathSplit = this.doc['path'].split('/');
        const nameUnformatted = pathSplit[pathSplit.length - 2];
        const nameSplit = nameUnformatted.split('_');
        if (nameSplit.length > 1) {
          this.doc['name'] = nameSplit.join(' ');
        } else {
          this.doc['name'] = nameSplit;
        }
        this.doc['type'] = this.doc.name.toString().toUpperCase();
      } else {
        this.doc['name'] = 'Inconnu';
      }
    }
  }

  // Visualise le document
  public goToDocument(document): void {
    if(document){
      window.open(this.rawMediaURL + document.path + document.filename , "_blank");
    }
  }

  public deleteAttachment(file) {
    if (file.id){
      this.documentService.deleteDocument(file.id).subscribe((data) => {
        if (data['status'] == 'success') {
          this.alertService.openSnackBar('Document supprimé !', 'snack-success');
          this.isDeleted.emit(file.id);
        } else {
          this.alertService.openSnackBar('Souci à la suppression.', 'snack-error');
        }
      });
    }
  }



  updateFormValues(event: any) {
    let selectedValue = event.value;
    let elements = selectedValue.split("_");
    let rent = elements[0];
    let name = elements[1];
    let address = elements[2];

    this.form.controls.rent.setValue(rent);
    this.form.controls.name.setValue(name);
    this.form.controls.address.setValue(address);

  }



  public onFileUpload(event):void {
    if (event && this.reload) {
      window.location.reload();
    }
  }


  public openModal(modal): void {
    this.modalService.open(modal, {centered: true, size:'md'})
  }

  public regenerateHC():void {
    this.isRegenerating = true;
    this.documentService.genPdf('ATT_LGT', this.doc.user_id).pipe(
      first(),
      finalize( () => {
        this.isRegenerating = false;
      } )
      ).subscribe(() => {
      this.alertService.openSnackBar('Document regénéré correctement', 'snack-success');
    }, ()=> {
      this.alertService.openSnackBar('Souci à la génération du document.', 'snack-error');
    })
    window.location.reload();
  }

  public checkDocument(key, modal) {
    if (this.platformService.isBrowserPlatform()) {
      this.dService.validateDocument(key).subscribe(
        (data) => {
          this.fullInfo = data.infos;
          this.form = this.fb.group({
            username: [data.infos?.username, Validators.required],
            birthdate: [data.infos?.birthdate, Validators.required],
            birthplace: [data.infos?.birthplace, Validators.required],
            address: [data.infos?.address, Validators.required],
            rent: [data.infos?.rent, Validators.required],
            name: [data.infos?.name, Validators.required],
            stayDuration: [data.user?.stayDuration, Validators.required],
            arrivalDate: [data.user?.arrivalDate, Validators.required],
            validity: [],
          })
          this.hasLoad = true;
          this.modalService.open(modal, {centered: true, size: 'md'});
        }
      )
    }
  }

  public updateDocument(){
    this.loading = true;

    const send = {
      username: this.form.controls.username.value,
      birthdate: this.form.controls.birthdate.value,
      birthplace: this.form.controls.birthplace.value,
      address: this.form.controls.address.value,
      rent: this.form.controls.rent.value,
      name: this.form.controls.name.value,
      arrivalDate: formatDate(this.form.value.arrivalDate, 'yyyy-MM-dd', 'fr-FR'),
      stayDuration: this.form.controls.stayDuration.value,
    };
    if (this.fullInfo && this.fullInfo.property_id) {
      send['property_id'] = this.fullInfo.property_id;
    }
    this.documentService.updateDocument(this.doc['accessKey'], send).subscribe(
      (data) => {
        if (data) {
          this.alertService.openSnackBar('Document correctement mis à jour', 'snack-success');
          this.modalService.dismissAll();
          this.loading = false;
          window.location.reload();
        } else {
          this.alertService.openSnackBar('Erreur de mise à jour du document.', 'snack-error');
          this.loading = false;
        }
      },
      (error) =>{
        this.alertService.openSnackBar('Erreur de mise à jour du document.', 'snack-error');
        this.loading = false;
      }
      )
  }

  public updateValidity(){
    this.loading = true;
    const send = {
      validity: formatDate(this.form.value.validity, 'yyyy-MM-dd', 'fr-FR'),
    };
    this.documentService.updateValidity(this.doc['accessKey'], send).subscribe(
      (data) => {
        if (data) {
          this.alertService.openSnackBar('Date de validité modifiée', 'snack-success');
          this.modalService.dismissAll();
          this.loading = false;
          window.location.reload();
        } else {
          this.alertService.openSnackBar('Erreur de mise à jour du document.', 'snack-error');
          this.loading = false;
        }
      },
      (error) =>{
        this.alertService.openSnackBar('Erreur de mise à jour du document.', 'snack-error');
        this.loading = false;
      }
    )
  }

  public getPropertiesRefs(){
    this.dService.getAllPropertiesForCertificate().subscribe((resp: any[]) => {
      console.log(resp)
      resp.forEach(element => {
        this.properties.push({
          value:
            element.price +'_'+
            element.name +'_'+
            element.address+','+
            element.city,
          label:
            element.id + ' - ' +
            element.city + ' ' +
            '(' + element.metropoleName + ')' + ' - ' +
            element.price +' €'
        });
      });
    });
  }
}
